import { getDatesForFewMonths } from './getDatesForFewMonths.main';

export { getDatesForFewMonths };
